import {isEmpty} from 'lodash-es';
import {connect as refetchConnect} from 'react-refetch';

import {SearchServiceApi, APIFetcher} from 'static/three-oh/src/modules/apis';

import SuggestionList from '../../components/SuggestionList/SuggestionList.jsx';


const BASE_PATH = SearchServiceApi.suggestionsConfig.basePath;

// Default Promise State is always resolved to an empty list by react-refetch.
const DEFAULT_PROMISE_STATE = {value: []};

/**
 * Create a search suggestions request URL based on the query term.
 *
 * @param {Object} props
 * @return {string|Object}
 */
export const createSearchSuggestionsUrl = (props) => {
  const {queryTerm} = props;
  const searchParams = {
    needle: queryTerm,
  };

  // When the query term is empty, avoid endpoint calls by passing a
  // DEFAULT_PROMISE_STATE object that is immediately resolved without a server
  // call by react-refetch.
  if (isEmpty(queryTerm)) {
    return DEFAULT_PROMISE_STATE;
  }

  const stringifiedSearchParams = APIFetcher.stringifyParams(searchParams);
  return `${BASE_PATH}?${stringifiedSearchParams}`;
};

/**
 * Define the SuggestionListContainer. Inject 'suggestions' as props to
 * SuggestionList with a type of {react-refetch.PromiseState}.
 */
const refetchConnectWithDefaults = refetchConnect.defaults({
  credentials: 'include'
});
const SuggestionListContainer = refetchConnectWithDefaults((props) => {
  return {
    suggestions: createSearchSuggestionsUrl(props),
  };
})(SuggestionList);

export default SuggestionListContainer;
